module.exports = window.ko;